import { render, staticRenderFns } from "./tvr_basic.vue?vue&type=template&id=ea7ee8e4&scoped=true"
import script from "./tvr_basic.vue?vue&type=script&lang=js"
export * from "./tvr_basic.vue?vue&type=script&lang=js"
import style0 from "./tvr_basic.vue?vue&type=style&index=0&id=ea7ee8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7ee8e4",
  null
  
)

export default component.exports